import { isAddress } from 'ethers/lib/utils';
import { ALMLeverageDataProvider__factory } from './typechain/ALMLeverageDataProvider__factory';
export class ALMLeverageDataProvider {
    constructor(context) {
        if (!isAddress(context.leverageDataProviderAddress)) {
            throw new Error('contract address is not valid');
        }
        this._contract = ALMLeverageDataProvider__factory.connect(context.leverageDataProviderAddress, context.provider);
    }
    async getPoolData({ vaultAddress }) {
        return this._contract.getPoolData(vaultAddress);
    }
    async getPositionsData({ positionAddresses }) {
        return this._contract.getPositionsData(positionAddresses);
    }
}
//# sourceMappingURL=index.js.map